<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div#contact-button{
        background-color: $secondary-color;
        width: 56px;
        height: 56px;
        border-radius: 50px;
        -webkit-box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
        box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14), 0 3px 1px -2px rgba(0,0,0,0.12), 0 1px 5px 0 rgba(0,0,0,0.2);
        text-align: center;
        z-index: 9;
        cursor: pointer;
        position: absolute;
        right: 60px;
        bottom: 10px;
        color: white;
        line-height: 50px;
        font-size: 40px;
        transition: all 0.2s ease-in-out;

        &:hover {
            box-shadow: 0px 0px 15px 1px #777777;
            transform: scale(1.05);
        }

        img {
            height: 28px;
            width: 28px;
        }
    }
</style>

<template>
    <div id="contact-button" v-on:click="contactButton()">
        <img src="/img/icons/envelope.svg" />
    </div>
</template>

<script>
    import { EventBus } from '../../event-bus.js';

    export default {
        methods: {
            contactButton() {
                EventBus.$emit('prompt-contact');
            }
        }
    }
</script>
